/**
 * `round F2`, `F2.3`: **the photograph views come from the api, and this file
 * holds none of them.**
 *
 * The first cut transcribed the twelve into the front, and
 * `hakili/no-french-outside-catalogue` refused it , correctly, and for a better
 * reason than the one the message gives. These names are **wire values**:
 * `catalog.vehicle_photos.view_name` stores them and the upload door compares
 * them. A copy in a screen is a copy that drifts, and they cannot live in the
 * `fr-ML` catalogue either, because a catalogue key is copy a translator may
 * change and these are data a database matches.
 *
 * So `GET /api/v1/reference/photo-views` answers them, beside the cities and
 * the zones, and this file is the shape of that answer.
 */

/**
 * One view: **what the api stores, and what a person reads.**
 *
 * They are equal today and are carried apart anyway. `key` is the value
 * `catalog.vehicle_photos.view_name` holds and the upload door compares , a
 * wire value, which never changes. `label` is copy, which may. A screen that
 * kept one string for both would, the first time a label was reworded, either
 * rename a column's contents or send a string no row matches.
 *
 * The rule this file exists to hold: **show the label, send the key.**
 */
export interface PhotoView {
  readonly key: string;
  readonly label: string;
}

/** What the reference door answers. */
export interface PhotoViews {
  /** The eight the add panel draws as named slots. */
  readonly recommended: readonly PhotoView[];
  /** The four behind « Autres photos ». */
  readonly other: readonly PhotoView[];
  /**
   * The catch-all's own wire value, and a bare key on purpose: `autre` is not
   * a view, it is never rendered, and the section above it is titled from this
   * app's own catalogue.
   */
  readonly otherView: string;
}

/**
 * What a panel shows before the door has answered.
 *
 * Empty, deliberately: eight slots drawn from a guess would be eight slots that
 * flicker into different names, and a panel with no slots for one paint reads
 * as a panel still loading , which is what it is.
 */
export const NO_VIEWS: PhotoViews = { recommended: [], other: [], otherView: "autre" };
